/**
 * public/ 下资源在浏览器中的绝对路径。
 * 与 src/pages/_app.js 中 `NEXT_PUBLIC_DEV ? "" : NEXT_PUBLIC_cdn + "/public"` 一致。
 *
 * 生产环境 next.config 的 assetPrefix 会把打包 CSS 放到 CDN；Less 里写的 `url(/…)`
 * 常被解析为「CDN 主机 + /…」，而静态文件实际在「CDN + /public/…」，导致线上 404、本地正常。
 * 在组件里用行内 style + 本函数生成的 URL，会按 CDN 规则加载，与开发环境一致。
 *
 * @param {string} relativePath — 如 `images/ai-lab/foo.png` 或 `/images/ai-lab/foo.png`
 */
export function publicAssetUrl(relativePath) {
  const rel = `/${String(relativePath || "").replace(/^\/+/, "")}`;
  if (process.env.NEXT_PUBLIC_DEV) return rel;
  const cdn = process.env.NEXT_PUBLIC_cdn;
  if (cdn) return `${cdn}/public${rel}`;
  return rel;
}

export function publicSvgUrl(filename) {
  const name = (filename || "").replace(/^\//, "");
  return publicAssetUrl(`/svg/${name}`);
}
